// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Quicksand:100,300,700|Roboto:100,300,500,700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	margin: 0;
	font-family: 'Roboto', sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
	margin: 5px 0;
}

h1 {
	font-weight: bold;
	font-size: 30px;
	text-transform: uppercase;
}

h2,
h3 {
	font-size: 25px;
	font-weight: 300;
}

.dark h1,
.dark h2,
.dark h3 {
	color: #fff;
}

.black-friday h1,
.black-friday h2,
.black-friday h3 {
	color: #fff;
	text-transform: uppercase;
}

.container {
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	box-sizing: border-box;
	flex-flow: row wrap;
	margin: 0 auto;
	padding: 15px;
}

.item {}

.justify-center {
	justify-content: center;
}

.justify-end {
	justify-content: flex-end;
}

.justify-start {
	justify-content: flex-start;
}

.text-bullets-wrapper {
	padding: 0 50px;
	background: rgba(255, 255, 255, 0.4);
	border-radius: 30px;
}

.text-bullets-wrapper div {
	margin: 0 !important;
	background: none !important;
	border-bottom: 1px solid #fff;
	border-radius: 0 !important;
}

.text-bullets-wrapper div:last-of-type {
	border: 0 !important;
}

.activeBullet {
	cursor: pointer;
}

.bullet-next {
	text-transform: uppercase;
}

.bullet-next.disabled {
	background: #84b088 !important;
}

.black-friday .bullet-next.disabled {
	background: #864545 !important;
}

.black-friday .activeBullet {
	background: rgba(255, 255, 255, 0.25) !important
}

.black-friday .bullet-next {
	background: #cc1c22 !important;
}

.black-friday .activeBullet.checked {
	border-color: #cc1c22 !important;
	background: rgba(0, 0, 0, 1) !important;
}

.black-friday .text-bullets-wrapper {
	background: rgba(255, 255, 255, 0.25);
}

.black-friday .text-bullets-wrapper div {
	border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}

.black-friday .reg-form .form-submit {
	background: #cc1c22;
	border: 0;
}

.black-friday .reg-form input {
	background: rgba(0, 0, 0, 0.8);
	color: #fff;
}

.reg-footer {
	font-weight: 300;
	font-size: 14px;
	color: rgb(210, 210, 210);
	margin: 12px 0 30px 0;
}

.reg-footer a {
	font-weight: 400;
	color: rgb(255, 255, 255);
}

.transitionZoom {
	transition: all .2s ease-in-out;
}

.transitionZoom:hover {
	transform: scale(1.06);
}


.spinner {
	width: 48px;
	height: 48px;
	display: block;
	border-radius: 50%;
	position: relative;
	animation: rotate 1s linear infinite
}

.spinner::before {
	content: "";
	box-sizing: border-box;
	position: absolute;
	inset: 0px;
	border-radius: 50%;
	border: 5px solid #fff;
	animation: prixClipFix 2s linear infinite;
}

.spinner-mask {
    background: rgba(0, 0, 0, 0.1);
    position: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

@keyframes rotate {
	100% {
		transform: rotate(360deg)
	}
}

@keyframes prixClipFix {
	0% {
		clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0)
	}

	25% {
		clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0)
	}

	50% {
		clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%)
	}

	75% {
		clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%)
	}

	100% {
		clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0)
	}
}

@media screen and (min-width: 1024px) {
	.activeBullet:hover {
		background: rgba(68, 116, 171, 0.6) !important;
		font-weight: 600;
		border: 2px solid #4a7097;
		padding: 13px !important;
	}

	.black-friday .activeBullet:hover {
		background: rgba(204, 28, 34, 0.6) !important;
		border: 2px solid #cc1c22;
	}
}

@media screen and (max-width: 767px) {
	.text-bullets-wrapper {
		padding: 0 30px;
	}
}

@media screen and (max-width: 450px) {

	h1,
	h2 {
		font-size: 24px;
	}
}`, "",{"version":3,"sources":["webpack://./Content/Css/lpGeneral.css"],"names":[],"mappings":"AAEA;CACC,SAAS;CACT,iCAAiC;AAClC;;AAEA;;;;;;CAMC,aAAa;AACd;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,yBAAyB;AAC1B;;AAEA;;CAEC,eAAe;CACf,gBAAgB;AACjB;;AAEA;;;CAGC,WAAW;AACZ;;AAEA;;;CAGC,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,aAAa;CACb,eAAe;CACf,sBAAsB;CACtB,mBAAmB;CACnB,cAAc;CACd,aAAa;AACd;;AAEA,OAAO;;AAEP;CACC,uBAAuB;AACxB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,oCAAoC;CACpC,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;CACpB,2BAA2B;CAC3B,6BAA6B;CAC7B,2BAA2B;AAC5B;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC;AACD;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,gCAAgC;CAChC,uCAAuC;AACxC;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,iDAAiD;AAClD;;AAEA;CACC,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,8BAA8B;CAC9B,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,sBAAsB;AACvB;;;AAGA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,kBAAkB;CAClB;AACD;;AAEA;CACC,WAAW;CACX,sBAAsB;CACtB,kBAAkB;CAClB,UAAU;CACV,kBAAkB;CAClB,sBAAsB;CACtB,yCAAyC;AAC1C;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC,8CAA8C;EAC9C,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;CACzB;;CAEA;EACC,6CAA6C;EAC7C,yBAAyB;CAC1B;AACD;;AAEA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;;CAEC;;EAEC,eAAe;CAChB;AACD","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Quicksand:100,300,700|Roboto:100,300,500,700\");\r\n\r\nbody {\r\n\tmargin: 0;\r\n\tfont-family: 'Roboto', sans-serif;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n\tmargin: 5px 0;\r\n}\r\n\r\nh1 {\r\n\tfont-weight: bold;\r\n\tfont-size: 30px;\r\n\ttext-transform: uppercase;\r\n}\r\n\r\nh2,\r\nh3 {\r\n\tfont-size: 25px;\r\n\tfont-weight: 300;\r\n}\r\n\r\n.dark h1,\r\n.dark h2,\r\n.dark h3 {\r\n\tcolor: #fff;\r\n}\r\n\r\n.black-friday h1,\r\n.black-friday h2,\r\n.black-friday h3 {\r\n\tcolor: #fff;\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.container {\r\n\twidth: 100%;\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\tbox-sizing: border-box;\r\n\tflex-flow: row wrap;\r\n\tmargin: 0 auto;\r\n\tpadding: 15px;\r\n}\r\n\r\n.item {}\r\n\r\n.justify-center {\r\n\tjustify-content: center;\r\n}\r\n\r\n.justify-end {\r\n\tjustify-content: flex-end;\r\n}\r\n\r\n.justify-start {\r\n\tjustify-content: flex-start;\r\n}\r\n\r\n.text-bullets-wrapper {\r\n\tpadding: 0 50px;\r\n\tbackground: rgba(255, 255, 255, 0.4);\r\n\tborder-radius: 30px;\r\n}\r\n\r\n.text-bullets-wrapper div {\r\n\tmargin: 0 !important;\r\n\tbackground: none !important;\r\n\tborder-bottom: 1px solid #fff;\r\n\tborder-radius: 0 !important;\r\n}\r\n\r\n.text-bullets-wrapper div:last-of-type {\r\n\tborder: 0 !important;\r\n}\r\n\r\n.activeBullet {\r\n\tcursor: pointer;\r\n}\r\n\r\n.bullet-next {\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.bullet-next.disabled {\r\n\tbackground: #84b088 !important;\r\n}\r\n\r\n.black-friday .bullet-next.disabled {\r\n\tbackground: #864545 !important;\r\n}\r\n\r\n.black-friday .activeBullet {\r\n\tbackground: rgba(255, 255, 255, 0.25) !important\r\n}\r\n\r\n.black-friday .bullet-next {\r\n\tbackground: #cc1c22 !important;\r\n}\r\n\r\n.black-friday .activeBullet.checked {\r\n\tborder-color: #cc1c22 !important;\r\n\tbackground: rgba(0, 0, 0, 1) !important;\r\n}\r\n\r\n.black-friday .text-bullets-wrapper {\r\n\tbackground: rgba(255, 255, 255, 0.25);\r\n}\r\n\r\n.black-friday .text-bullets-wrapper div {\r\n\tborder-bottom: 1px solid rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.black-friday .reg-form .form-submit {\r\n\tbackground: #cc1c22;\r\n\tborder: 0;\r\n}\r\n\r\n.black-friday .reg-form input {\r\n\tbackground: rgba(0, 0, 0, 0.8);\r\n\tcolor: #fff;\r\n}\r\n\r\n.reg-footer {\r\n\tfont-weight: 300;\r\n\tfont-size: 14px;\r\n\tcolor: rgb(210, 210, 210);\r\n\tmargin: 12px 0 30px 0;\r\n}\r\n\r\n.reg-footer a {\r\n\tfont-weight: 400;\r\n\tcolor: rgb(255, 255, 255);\r\n}\r\n\r\n.transitionZoom {\r\n\ttransition: all .2s ease-in-out;\r\n}\r\n\r\n.transitionZoom:hover {\r\n\ttransform: scale(1.06);\r\n}\r\n\r\n\r\n.spinner {\r\n\twidth: 48px;\r\n\theight: 48px;\r\n\tdisplay: block;\r\n\tborder-radius: 50%;\r\n\tposition: relative;\r\n\tanimation: rotate 1s linear infinite\r\n}\r\n\r\n.spinner::before {\r\n\tcontent: \"\";\r\n\tbox-sizing: border-box;\r\n\tposition: absolute;\r\n\tinset: 0px;\r\n\tborder-radius: 50%;\r\n\tborder: 5px solid #fff;\r\n\tanimation: prixClipFix 2s linear infinite;\r\n}\r\n\r\n.spinner-mask {\r\n    background: rgba(0, 0, 0, 0.1);\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n@keyframes rotate {\r\n\t100% {\r\n\t\ttransform: rotate(360deg)\r\n\t}\r\n}\r\n\r\n@keyframes prixClipFix {\r\n\t0% {\r\n\t\tclip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0)\r\n\t}\r\n\r\n\t25% {\r\n\t\tclip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0)\r\n\t}\r\n\r\n\t50% {\r\n\t\tclip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%)\r\n\t}\r\n\r\n\t75% {\r\n\t\tclip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%)\r\n\t}\r\n\r\n\t100% {\r\n\t\tclip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0)\r\n\t}\r\n}\r\n\r\n@media screen and (min-width: 1024px) {\r\n\t.activeBullet:hover {\r\n\t\tbackground: rgba(68, 116, 171, 0.6) !important;\r\n\t\tfont-weight: 600;\r\n\t\tborder: 2px solid #4a7097;\r\n\t\tpadding: 13px !important;\r\n\t}\r\n\r\n\t.black-friday .activeBullet:hover {\r\n\t\tbackground: rgba(204, 28, 34, 0.6) !important;\r\n\t\tborder: 2px solid #cc1c22;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n\t.text-bullets-wrapper {\r\n\t\tpadding: 0 30px;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 450px) {\r\n\r\n\th1,\r\n\th2 {\r\n\t\tfont-size: 24px;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
